routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('editSettings', {
      url: '/edit/settings',
      template: require('./index.html'),
      controller: 'EditSettingsController',
      controllerAs: 'editSettings',
      authRequired: true,
      resolve: {
        secure: (panel) => {
          // todo: implement method
        }
      },
      onEnter: function (secure) {
        // todo: implement method
      }
    });
}



// WEBPACK FOOTER //
// ./src/app/features/edit-settings/routes.js